<wbo-select-option [value]="true" [label]="'wbo.common.option.boolean.yes'">
</wbo-select-option>
<wbo-select-option [value]="false" [label]="'wbo.common.option.boolean.no'">
</wbo-select-option>
